import React from "react";
import Slider from "../slick-wrapper";
import { PropTypes } from "prop-types";
import styles from "./styles.css";

const CarouselBottomArrow = ({children, settings, afterChange}) => {

    return (
        <div styleName={"styles.customCarousel"}>
            <Slider {...settings} afterChange={afterChange}>
                {children}
            </Slider>
        </div>
    );
};
CarouselBottomArrow.propTypes = {
    children: PropTypes.any,
    settings: PropTypes.object,
    afterChange: PropTypes.func
};
export default CarouselBottomArrow;
